import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getTemplateDetail } from 'services/templateService'
import { RootState } from 'store/store'
import HeaderPatternDetail from 'components/molecules/HeaderPatternDetail/HeaderPatternDetail'
import AppBox from 'components/atoms/AppBox/AppBox'
import { AccordionPattern } from 'components/molecules/AccordionPattern/AccordionPattern'
import moment from 'moment'
import { Criteria } from 'interfaces/patternDetails'
import ImageEmptyList from 'components/molecules/ImageEmptyList/ImageEmptyList'
import EmptyBox from '../../../assets/empty-box.png'
import { useNavigate } from 'react-router-dom'
import Layout from 'layout/Layout'
import Breadcrumb from 'components/atoms/Breadcrumb/Breadcrumb'
import arrowIcon from '../../../assets/arrowNext.png'
import AppButton from 'components/atoms/AppButton/AppButton'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'

interface Props {
    pattern: number
}

export default function PatternRulesList({ pattern }: Props) {
    const navigate = useNavigate()
    const { apiToken } = useSelector((state: RootState) => state.auth)
    const [loading, setLoading] = useState(false)
    const { can } = usePermissions()

    interface RuleGroup {
        id: number
        name: string
        chutes: number[]
        criterias: Criteria[]
    }

    interface RulesList {
        id: number | null
        created_at: string
        updated_at: string
        chutes_assigned: number[]
        chutes_not_assigned: number[]
        name: string
        groups: RuleGroup[]
    }

    const [rulesList, setRulesList] = useState<RulesList>({
        id: null,
        created_at: '',
        updated_at: '',
        chutes_assigned: [],
        chutes_not_assigned: [],
        name: '',
        groups: [],
    })

    const breadcrumbNavigate = [
        {
            label: 'Plantillas',
            path: '/templates',
        },
        {
            label: `${rulesList.name}`,
            path: '/packages/create',
        },
    ]

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const data = await getTemplateDetail(pattern)
                if (data !== undefined && data !== null) {
                    setRulesList(data)
                }
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }

        fetchData()
    }, [apiToken])

    return (
        <Layout>
            <div className="flex justify-between px-10 mt-10 items-end">
                <div>
                    <Breadcrumb
                        items={breadcrumbNavigate}
                        separator={<img src={arrowIcon} alt="arrowIcon" />}
                        title="Detalle de la plantilla"
                    />
                </div>
                {can(RolePermissions.templates.edit) && (
                    <AppButton
                        title="Agregar reglas"
                        state="primary"
                        className="text-sm font-bold mb-1"
                        onClick={() => navigate(`/templates/edit/${pattern}`)}
                    />
                )}
            </div>
            <>
                {loading && <LoaderTransparent />}
                <div className="px-10">
                    <div className="mt-6">
                        <HeaderPatternDetail
                            created={{
                                createdAt: moment(rulesList.created_at).format(
                                    'DD/MM/YYYY'
                                ),
                                hour: moment(rulesList.created_at).format(
                                    'HH:mm'
                                ),
                            }}
                            lastUpdate={
                                rulesList.updated_at
                                    ? {
                                          createdAt: moment(
                                              rulesList.updated_at
                                          ).format('DD/MM/YYYY'),
                                          hour: moment(
                                              rulesList.updated_at
                                          ).format('HH:mm'),
                                      }
                                    : {
                                          createdAt: 'No disponible',
                                          hour: 'No disponible',
                                      }
                            }
                            countRules={rulesList.groups.length}
                            chutesAssigned={
                                Array.isArray(rulesList.chutes_assigned)
                                    ? {
                                          totals: rulesList.chutes_assigned
                                              .length,
                                          notProcessed: Array.isArray(
                                              rulesList.chutes_not_assigned
                                          )
                                              ? rulesList.chutes_not_assigned
                                                    .length
                                              : 0,
                                      }
                                    : {
                                          totals: 0,
                                          notProcessed: 0,
                                      }
                            }
                        />
                        <AppBox>
                            <div className="bg-[#F1F5F9] px-[12px] py-2 flex justify-between items-center rounded-xl">
                                <p className="text-sm font-normal text-[#141A1F] w-2/3">
                                    Nombre de regla
                                </p>
                            </div>
                            <div
                                className="overflow-y-auto"
                                style={{ height: '500px' }}
                            >
                                {rulesList.groups.length > 0 ? (
                                    <div className="flex justify-center py-3 text-sm">
                                        <AccordionPattern
                                            rules={rulesList.groups}
                                        />
                                    </div>
                                ) : (
                                    <div className="flex justify-center p-4 text-sm">
                                        <ImageEmptyList
                                            image={EmptyBox}
                                            title="Aún no has agregado ninguna regla"
                                            description="Asigna una o más reglas para esta plantilla"
                                            textButton="Agregar reglas"
                                            onClick={() =>
                                                navigate(
                                                    `/templates/edit/${pattern}`
                                                )
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                        </AppBox>
                    </div>
                </div>
            </>
        </Layout>
    )
}
